<script setup lang="ts">
import {onBeforeMount, reactive} from "vue";
import activiteitRepository, {Aanbieder} from "@/repositories/activiteit.repository";
import Rating from "@/components/Rating.vue";
import Loader from "@/components/Loader.vue";
import {notify} from "@kyvg/vue3-notification";

const props = defineProps<{
    id: string,
    activitySingular: string,
    activityPlural: string,
}>();

const state = reactive<{
    isLoading: boolean,
    club?: Aanbieder,
    clubUrl: string,
    activities: string[],
}>({
    isLoading: false,
    clubUrl: "",
    activities: [],
});

const getClub = (id: string) => {
    activiteitRepository.search({
        type: "sportaanbod",
        OrderBy: "StartDatum",
        groupBy: "Sportaanbieder",
        sportaanbieder: id,
        pageSize: 1
    })
        .then(response => {
            const club = response.Groups[0].GroupFields[0].Entity;
            state.club = club;
            state.clubUrl = `/club-detail?id=${club.Id}`
            state.activities = club.SportenTranslated.concat(club.CultuuractiviteitenTranslated);
        })
        .catch(() => notify({
            type: 'error',
            title: 'Er is een fout opgetreden bij het ophalen van de club gegevens',
            duration: 20000
        }))
        .finally(() => state.isLoading = false);
}

onBeforeMount(async () => {
    getClub(props.id);
})
</script>

<template>
    <Loader v-if="state.isLoading" :is-active="state.isLoading" />
    <div v-else-if="state.club" class="sport-in-card sport-in-card-club">
        <div class="card-content">
            <div class="card-content-text">
                <a target="_self" :href="state.clubUrl">
                    <h3 class="card-title">{{ state.club.Naam }}</h3>
                </a>
                <ul class="card-sports">
                    <li v-for="(activity, index) in state.activities.slice(0, 3)" class="sport">
                        <span class="mr-1">
                            {{ activity }}{{ index < state.activities.length - 1 ? ',' : '' }}
                        </span>
                    </li>
                    <li v-if="state.activities.length > 3" class="sport">
                        (+ {{ state.activities.length - 3 }})
                    </li>
                </ul>
                <a class="more-activities" target="_self"
                   :href="state.clubUrl">
                    Bekijk {{ state.club.Activiteiten }}
                    {{ state.club.Activiteiten === 1 ? activitySingular : activityPlural }}
                </a>
            </div>
            <div class="card-activity-provider">
                <a target="_self" :href="state.clubUrl">
                    <Rating :rating="state.club.ReviewScore" :count="state.club.ReviewCount"/>
                </a>
            </div>
        </div>
    </div>
</template>
